import * as React from 'react';
import { useRecordContext } from 'react-admin';

import { Box, makeStyles, Typography } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import moment from 'moment';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  text: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '400px',
    // color: 'red',
  },
}));

const DataNegociadaField = (props) => {
  const classes = useStyles();

  const record = useRecordContext(props);

  const value = record
    ? record.record.agendamento_data
      ? moment(new Date(record.record.agendamento_data)).format(
          'DD/MM/YYYY - HH:mm',
        )
      : '-'
    : '-';

  return <Typography className={classes.text}>{value}</Typography>;
};

export default DataNegociadaField;
